import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {WizardInterfaces} from '../../wizard.namespace';

@Injectable()
export class EquipmentDataService {
    public methodId$ = new BehaviorSubject<number>(null);
    public methodTitle$ = new BehaviorSubject<string>(null);
    public attestation$ = new BehaviorSubject<WizardInterfaces.AttestationValue>(null);
    public group$ = new BehaviorSubject<WizardInterfaces.ApparatusStepGroup>(null);
    public isReference$ = new BehaviorSubject<boolean>(false);
}
